export enum InputVariant {
    Normal = 'normal',
    Error = 'error',
}
